import { render } from "./ComponentModal.vue?vue&type=template&id=64099149"
import script from "./ComponentModal.vue?vue&type=script&lang=js"
export * from "./ComponentModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__